<template>
  <div
    class="template-with-block"
    :class="device.isMobile ? 'template-with-block-mobile' : ''"
    :id="content.key"
    :style="{
      fontFamily: content.templateStyle.fontFamily || '',

      fontSize: content.templateStyle.fontSize + 'rem' || '',
      lineHeight: content.templateStyle.lineHeight + 'rem' || '',
      textIndent:
        content.templateStyle.textIndent &&
        typeof content.templateStyle.textIndent === 'string'
          ? content.templateStyle.textIndent
          : content.templateStyle.textIndent &&
            typeof content.templateStyle.textIndent === 'number'
          ? content.templateStyle.textIndent + 'rem'
          : '',
      fontWeight: content.templateStyle.fontWeight || '',
      textDecoration: content.templateStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.templateStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.templateStyle.textAlign || '',
      color: content.templateStyle.color || '',
      backgroundColor: content.templateStyle.backgroundColor || '',
      backgroundImage: content.templateStyle.backgroundImage ? `url(${content.templateStyle.backgroundImage})` : '',
      backgroundPosition: content.templateStyle.backgroundPosition || '',
      backgroundSize: content.templateStyle.backgroundSize || '',
      marginTop:
        (typeof content.templateStyle.marginTop === 'number' &&
          content.templateStyle.marginTop + 'rem') ||
        '',
      marginBottom:
        (typeof content.templateStyle.marginBottom === 'number' &&
          content.templateStyle.marginBottom + 'rem') ||
        '',
      width: (typeof content.templateStyle.width === 'string') ? content.templateStyle.width :
        (typeof content.templateStyle.width === 'number') ? (content.templateStyle.width + 'rem') : '',
      padding:
        (typeof content.templateStyle.padding === 'number' &&
          content.templateStyle.padding + 'rem') ||
        '',
      paddingTop:
        (typeof content.templateStyle.paddingTop === 'number' &&
          content.templateStyle.paddingTop + 'rem') ||
        '',
      paddingBottom:
        (typeof content.templateStyle.paddingBottom === 'number' &&
          content.templateStyle.paddingBottom + 'rem') ||
        '',
      borderRadius:
        (typeof content.templateStyle.borderRadius === 'number' &&
          content.templateStyle.borderRadius + 'rem') ||
        '',
      border: content.templateStyle.border || '',
      borderTop: content.templateStyle.borderTop || '',
      borderBottom: content.templateStyle.borderBottom || '',
      borderLeft: content.templateStyle.borderLeft || '',
      borderRight: content.templateStyle.borderRight || '',
      borderColor:content.showReset==2?'rgb(240, 248, 245)':''
    }"
  >
    <div
      v-if="content.showReset === 1"
      class="reset"
      @click.stop="reset"
      :style="{
        top:
          (typeof content.resetTop === 'number' && content.resetTop + 'rem') ||
          '',
        right:
          (typeof content.resetRight === 'number' &&
            content.resetRight + 'rem') ||
          '',
      }"
    ></div>
    <el-rate
      v-if="content.showReset === 2"
      v-model="content.rateValue"
      :colors="colors"
      class="rate"
    >
    </el-rate>
    <img
      class="evaluation_icon"
      v-if="content.templateType"
      :src="require('@/assets/images/books/book2/evaluation_icon.png')"
      alt=""
    />
    <div class="evaluation_title" v-if="content.templateType">
      My Self-Assessment Report
    </div>
    <div v-if="content.templateType" class="input_box">
      <div>Student: <span contenteditable></span></div>
      <div>Date: <span contenteditable></span></div>
    </div>
    <div v-if="content.showReset==3">
      {{ content[0].contentList }}
    </div>
    <commonIndex :bookContent="content.content"></commonIndex>
  </div>
</template>

<script>
/*
单个带边框结构
*/
export default {
  name: "singleWithBlock",
  components: {
    commonIndex: () => import("../../index.vue"), //解决递归加载组件报错
  },
  data() {
    return {
      value2: null,
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
    };
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    reset() {
      this.$bus.$emit("reset", this.content.key);
    },
  },
};
</script>

<style lang="scss" scoped>
.template-with-block {
  width: calc(100% - 48rem);
  margin: 0rem auto;
  padding: 30rem 20rem;
  border: 1px solid #5ca683;
  border-radius: 10rem;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.1);
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  .reset {
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center
      no-repeat;
    background-size: contain;
    position: absolute;
    top: 10rem;
    right: 10rem;
    cursor: pointer;
    z-index: 5;
  }
  .rate{
    position: absolute;
    top: 10rem;
    right: 10rem;
    z-index: 5;
  }
}
.template-with-block-mobile {
  .reset {
    width: 44rem;
    height: 44rem;
  }
}
.evaluation_icon {
  position: absolute;
  top: -80rem;
  left: 50%;
  transform: translateX(-50%);
  width: 100rem;
  height: 80rem;
}
.evaluation_title {
  width: 380rem;
  height: 60rem;
  line-height: 60rem;
  text-align: center;
  color: #fff;
  font-size: 26rem;
  border-radius: 10rem;
  background: #5ca683;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
}
.input_box {
  display: flex;
  margin-top: 50rem;
  padding: 0 20rem 56rem 20rem;
  justify-content: space-between;
  div {
    flex: 0 0 48%;
    color: #333333;
    font-size: 28rem;
    overflow: hidden;

    span {
      min-width: 180rem;
      border-bottom: 1rem solid #333;
      outline: none;
      display: inline-block;
      word-break: break-word;
    }

    &:last-child{
      span{
        min-width: 210rem;
      }
    }
  }
}
/deep/.el-rate__icon{
  font-size:22px !important;
}
</style>
